/**
 * @license lucide-vue-next v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const WifiZero = createLucideIcon("wifi-zero", [["path", { d: "M12 20h.01", key: "zekei9" }]]);

export { WifiZero as default };
//# sourceMappingURL=wifi-zero.js.map
